define("shared/components/shared/credentials/instagram-auth-status/social-profile-item", ["exports", "@ember/component", "@ember/service", "@glimmer/component", "@ember/template-factory"], function (_exports, _component, _service, _component2, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _dec, _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/service",0,"@glimmer/component",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div class="tAC--status {{this.profileStatusCss}}">
    <div class="u--row u--row--noCollapse u--flex u--flex__justify--between u--flex__alignItems--center">
      <div class="u--col__5">
        <Shared::ProfileAvatar @showPlatform={{true}} @socialProfile={{this.socialProfile}}>
          <span class="o--user__title u--text--hair {{this.profileStatusTextCss}}">
            {{this.socialProfile.nickname}}
          </span>
          <span class="o--user__desc {{this.profileStatusTextCss}}">
            {{t "shared_words.instagram"}}
          </span>
        </Shared::ProfileAvatar>
      </div>
      <div class="u--col__7 u--text--right {{this.profileStatusTextCss}}">
        {{#if this.needsRefresh}}
          <div class="u--flex u--flex__justify--end u--flex__alignItems--center">
            {{#if this.unavailableReason}}
              <span>{{this.unavailableReason}}</span>
            {{/if}}
            {{#if @isRunning}}
              <span>{{svg-jar "refresh" class="o--icon o--icon--warning u--m__l__sm u--spin"}}</span>
            {{else}}
              <span>{{svg-jar "warning" class="o--icon o--icon--danger u--m__l__sm"}}</span>
            {{/if}}
          </div>
        {{else}}
          {{svg-jar "check" class="o--icon o--icon--success u--m__l__xs"}}
        {{/if}}
      </div>
    </div>
  </div>
  */
  {
    "id": "CzoCQDBK",
    "block": "[[[10,0],[15,0,[29,[\"tAC--status \",[30,0,[\"profileStatusCss\"]]]]],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--row u--row--noCollapse u--flex u--flex__justify--between u--flex__alignItems--center\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n      \"],[8,[39,0],null,[[\"@showPlatform\",\"@socialProfile\"],[true,[30,0,[\"socialProfile\"]]]],[[\"default\"],[[[[1,\"\\n        \"],[10,1],[15,0,[29,[\"o--user__title u--text--hair \",[30,0,[\"profileStatusTextCss\"]]]]],[12],[1,\"\\n          \"],[1,[30,0,[\"socialProfile\",\"nickname\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,1],[15,0,[29,[\"o--user__desc \",[30,0,[\"profileStatusTextCss\"]]]]],[12],[1,\"\\n          \"],[1,[28,[35,1],[\"shared_words.instagram\"],null]],[1,\"\\n        \"],[13],[1,\"\\n      \"]],[]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[15,0,[29,[\"u--col__7 u--text--right \",[30,0,[\"profileStatusTextCss\"]]]]],[12],[1,\"\\n\"],[41,[30,0,[\"needsRefresh\"]],[[[1,\"        \"],[10,0],[14,0,\"u--flex u--flex__justify--end u--flex__alignItems--center\"],[12],[1,\"\\n\"],[41,[30,0,[\"unavailableReason\"]],[[[1,\"            \"],[10,1],[12],[1,[30,0,[\"unavailableReason\"]]],[13],[1,\"\\n\"]],[]],null],[41,[30,1],[[[1,\"            \"],[10,1],[12],[1,[28,[35,3],[\"refresh\"],[[\"class\"],[\"o--icon o--icon--warning u--m__l__sm u--spin\"]]]],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[10,1],[12],[1,[28,[35,3],[\"warning\"],[[\"class\"],[\"o--icon o--icon--danger u--m__l__sm\"]]]],[13],[1,\"\\n\"]],[]]],[1,\"        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[1,[28,[35,3],[\"check\"],[[\"class\"],[\"o--icon o--icon--success u--m__l__xs\"]]]],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13]],[\"@isRunning\"],false,[\"shared/profile-avatar\",\"t\",\"if\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/credentials/instagram-auth-status/social-profile-item.hbs",
    "isStrictMode": false
  });
  let SocialProfileItemComponent = _exports.default = (_dec = (0, _service.service)('social/instagram-auth'), (_class = class SocialProfileItemComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "intl", _descriptor, this);
      _initializerDefineProperty(this, "instagramAuth", _descriptor2, this);
    }
    get socialProfile() {
      return this.args.socialProfile;
    }
    get needsRefresh() {
      return this.socialProfile.needsRefresh;
    }
    get profileStatusCss() {
      if (!this.needsRefresh) {
        return 'tAC--status--success';
      }
      if (this.args.isRunning) {
        return 'tAC--status--warning';
      }
      return 'tAC--status--danger';
    }
    get profileStatusTextCss() {
      if (!this.needsRefresh) {
        return 'u--text--success';
      }
      if (this.args.isRunning) {
        return 'u--text--warning';
      }
      return 'u--text--danger';
    }
    get unavailableReason() {
      if (!this.needsRefresh) {
        return '';
      }
      if (this.args.isRunning) {
        return this.intl.t('shared_words.refreshing');
      }
      if (!this.args.socialProfile.isInstagramLogin) {
        if (!this.instagramAuth.facebookPages) {
          return this.intl.t('shared_phrases.social_sets.connection_expired');
        }
        const facebookPageWithInstagramProfile = this.instagramAuth.facebookPages?.find(facebookPage => facebookPage.instagram_business_account?.username === this.socialProfile.nickname);
        if (!facebookPageWithInstagramProfile) {
          return this.intl.t('credentials.instagram_auth_status.no_fb_linked');
        }
        const requiredTasks = ['ADVERTISE', 'ANALYZE', 'MODERATE', 'CREATE_CONTENT'];
        const hasRequiredTasks = requiredTasks.every(requiredTask => facebookPageWithInstagramProfile?.tasks.includes(requiredTask));
        if (!hasRequiredTasks) {
          return this.intl.t('credentials.instagram_auth_status.no_permission');
        }
      }
      return this.intl.t('shared_phrases.social_sets.connection_expired');
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "instagramAuth", [_dec], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  })), _class));
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SocialProfileItemComponent);
});